const loadShare = (callback) => {
    const existingScript = document.getElementById('addThis')
    if (!existingScript) {
      const script = document.createElement('script')
      script.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=6018548e925b0d0018b91d63&product=sop'
      script.id = 'addThis'
      script.async = 'async'
      document.body.appendChild(script)
      script.onload = () => { 
        if (callback) callback()
      }
    }
    if (existingScript && callback) callback()
  }

  export default loadShare